import { memo, useRef } from 'react';
import { useGetDocumentAllowedExtensionsList } from '@views/screens/common/hooks';
import { Col, Divider, Form, Row } from 'antd';
import { t } from 'i18next';

import { ENV_VARS } from '@/env';
import { useRegisterForm } from '@/modules/validators';
import { generateUUIDv4 } from '@/utils/number';

import { MODULES_ID } from '../../../../../../../contants/common';
import Button from '../../../../../../components/Buttons/Button';
import HiddenFormInput from '../../../../../../components/Inputs/HiddenFormInput';
import HallFilesDetailsCard from '../../../Tabs/FilesDetails/HallFilesDetailsCard';

const isHBUser = ENV_VARS.REACT_APP_THEME === 'halliburton';

const HallDocumentDetails = () => {
  const [form] = Form.useForm();
  useRegisterForm(form, 'documentForm');
  const { data: allowedExtentions = [] } = useGetDocumentAllowedExtensionsList({ moduleId: MODULES_ID.SHIPMENT });
  const documents = Form.useWatch('documents', form);
  const documentsListRef = useRef([]);

  const handleAddNew = () => {
    const draftValue = { isNew: true, renderKey: generateUUIDv4() };
    form.setFieldValue(['documents', documents.length], draftValue);
    documentsListRef.current = form.getFieldValue('documents');
  };

  const handleDelete = (index) => {
    form.setFieldValue(
      'documents',
      documents.filter((_, i) => i !== index),
    );
    documentsListRef.current = form.getFieldValue('documents');
  };

  const handleSave = (data, _isNew, index) => {
    const documentsList = documentsListRef.current;

    data.isNew = documents[index].isNew;
    data.renderKey = documents[index].renderKey;
    documentsList[index] = data;

    form.setFieldValue('documents', documentsList);
  };

  return (
    <>
      <Form form={form} className="d-none" name="documentForm" initialValues={{ documents: [] }}>
        <HiddenFormInput name="documents" />
      </Form>

      <div className="d-flex h-100 flex-direction-column">
        <Row justify="end" gutter={16} align="middle">
          <Col>
            <Button
              dataTestId="document-details-add-new-file-button"
              onClick={handleAddNew}
              className={isHBUser ? 'hb-button' : ''}
            >
              {t('translation:default.documentManager.addNewFile')}
            </Button>
          </Col>
        </Row>
        <Divider className="my-16 vw-100 ml-n30" />
        <div>
          {documents?.length > 0 ? (
            documents.map((row, index) => (
              <HallFilesDetailsCard
                key={row.renderKey}
                fileDetails={row}
                handleDelete={handleDelete}
                handleSave={handleSave}
                isNew={row.isNew}
                index={index}
                allowedExtentions={allowedExtentions}
                isEditableField
                isDocumentButtonsEnabled
                hideEditButton
              />
            ))
          ) : (
            <></>
          )}
        </div>
      </div>
    </>
  );
};

export default memo(HallDocumentDetails);
